/* sb-dc-canvasclean.js — V0.1.5 캔버스 정리 (2026-09-10)

   사장님: «캔버스가 지저분하다. 빌드어사인처럼.» 시안(아티팩트) 대로:
     · 판 테두리는 선 1개 — 배너류는 연회색 실선, 스티커류는 재단선(다이컷) 1개
       (번들이 그리던 여유 점선 상자 · 여유 색칠 · 스티커의 네모 재단선은 숨김)
     · 안전영역은 노란 점선 1개 — «보기용» 이다. 검사(경고·주문 차단)와는
       무관하다. sb-dc-nosafe.js 가 끈 __dcShowSafe/__dcBaseSafe 는 그대로 둔다.
     · 그로밋 구멍은 손대지 않음(프루프 그림에도 같은 도형이 나간다)
     · 선택 손잡이는 얇은 남색 상자 + 작은 동그라미 8개 (회전 손잡이는 숨김 —
       아래 «회전» 단추가 같은 일을 한다)
     · 캔버스 옆 치수는 상품 단위대로 (배너 = ft, 스티커·스탠드 = in).
       기준은 사이즈 패널과 같은 카탈로그 unit (sb-dc-aug.js CATALOG).

   왜 이렇게: 그리는 쪽이 648KB 번들(sb-dc-app.js) 안이라 못 고친다. 그래서
   stagefit 처럼 «번들이 그린 것을 찾아 바깥에서 고쳐 쓴다».
     · Konva 안내선은 name 에 guide 가 있어 인쇄·프루프 렌더에서 번들이 스스로
       숨긴다(find('.guide') → visible(false)). 우리는 색·표시만 바꾸므로
       인쇄 파일에는 영향이 없다.
     · 안전영역 점선은 Konva 가 아니라 캔버스 칸 위에 얹은 <svg> 다. 인쇄·
       프루프는 Konva 레이어만 그리므로 애초에 들어갈 수 없다.
     · 번들이 다시 그리면(React 재렌더) 우리가 바꾼 값이 되돌아갈 수 있어
       0.2초마다 다시 맞춘다. 손잡이는 Konva.Transformer 가 «읽는» 함수
       (anchorStyleFunc·borderStroke…)를 덮어 두어 드래그 중에도 안 튄다.

   진단: window.__dcCanvasClean → { unit, safe, guides, ticks, draws }
   끄기: window.__dcCanvasClean.off()  (안내선은 번들 값으로 되돌리지 않는다 —
         새로고침이 되돌리기다) */
(function () {
  'use strict';

  var C = {
    line: '#B8C9D5',   // 배너 재단선 (--accent-line)
    cut:  '#7A93A8',   // 스티커 재단선
    safe: '#B9A63C',   // 안전영역 점선
    ink:  '#0A3A63',   // 선택 상자·손잡이 (--accent-2)
    ring: '#9AA9AC'    // 그로밋
  };
  var NS = 'http://www.w3.org/2000/svg';
  var SAFE_BASE_IN = 1;        // 마감 인셋이 없을 때의 보기용 안전영역 (번들 원래 baseSafeIn 값)
  var SAFE_DIE_IN  = 0.125;    // 스티커 안전영역
  var state = { unit: 'in', safe: null, guides: 0, ticks: 0, draws: 0, on: true };

  function stage() { var K = window.Konva; return (K && K.stages && K.stages[0]) || null; }
  function api()   { return window.__dcApi || null; }
  function die()   { try { return window.__dcDieShape ? window.__dcDieShape() : null; } catch (e) { return null; } }

  /* Konva 값은 «다를 때만» 넣는다 — Transformer 는 attr 이 바뀔 때마다 update()
     를 다시 부르므로, 같은 값을 계속 넣으면 무한 반복이 된다. */
  function same(a, b) { return JSON.stringify(a) === JSON.stringify(b); }
  function set(node, key, val) {
    var cur = node.getAttr(key);
    if (same(cur, val)) return false;
    node.setAttr(key, val);
    return true;
  }

  /* ── 1. 상품 단위 (사이즈 패널과 같은 근거) ───────────────────────── */
  function unit() {
    try {
      var h = window.__dcPopupHandle && window.__dcPopupHandle();
      var cat = window.__CAT || [];
      for (var i = 0; i < cat.length; i++) {
        var items = cat[i].items || [];
        for (var j = 0; j < items.length; j++) if (items[j].handle === h) return items[j].unit === 'ft' ? 'ft' : 'in';
      }
    } catch (e) {}
    return state.unit;
  }
  function fmt(v) { var r = Math.round(v * 100) / 100; return String(r); }
  /* 라벨은 «숫자 · in» 텍스트 노드 둘이다. React 는 «바뀐 노드만» 다시 쓰므로
     숫자는 새 인치로 바뀌어도 우리가 'ft' 로 바꿔 둔 단위 노드는 그대로 남는다
     (실측: 배너 → 라운드 스티커로 바뀌면 «3ft» 가 됐다). 그래서 우리가 쓴 값을
     data-sb-ft/in 에 적어 두고, 숫자가 우리 것과 다르면 React 가 새로 쓴 인치로
     본다. 단위가 in 인 상품이면 'in' 으로 되돌린다. */
  function dims() {
    var u = unit(); state.unit = u;
    var els = document.querySelectorAll('.dim-label');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], t = el.childNodes;
      if (t.length < 2) continue;
      var num = t[0].textContent, un = t[1].textContent, mine = el.getAttribute('data-sb-ft');
      var inch = (un === 'ft' && num === mine) ? parseFloat(el.getAttribute('data-sb-in')) : parseFloat(num);
      if (!isFinite(inch)) continue;
      if (u === 'ft') {
        var f = fmt(inch / 12);
        if (num !== f || un !== 'ft') { t[0].textContent = f; t[1].textContent = 'ft'; }
        el.setAttribute('data-sb-ft', f); el.setAttribute('data-sb-in', String(inch));
      } else {
        if (un !== 'in' || num !== String(inch)) { t[0].textContent = String(inch); t[1].textContent = 'in'; }
        el.removeAttribute('data-sb-ft'); el.removeAttribute('data-sb-in');
      }
    }
  }

  /* ── 2. 번들이 그린 안내선 ───────────────────────────────────────────
     처음 볼 때 원래 색으로 종류를 적어 두고(sbKind), 그 다음부터는 그 표로 본다.
       #9aa9ac 점선  → 여유 상자   (opacity 0)
       #00697F 실선  → 재단 상자   (배너: 연회색 1px · 스티커: opacity 0)
       #A82662 점선  → 안전영역    (nosafe 가 꺼 둠 · 손대지 않음)
       diecut        → 스티커 재단선 (실선 1px 회청색) */
  function classify(n) {
    var k = n.getAttr('sbKind');
    if (k) return k;
    if (n.hasName('snapline') || n.hasName('rotate-guide')) k = 'skip';
    else if (n.hasName('diecut')) k = 'die';
    else if (n.stroke() === '#9aa9ac') k = 'bleed';
    else if (n.stroke() === '#00697F') k = 'trim';
    else k = 'skip';
    n.setAttr('sbKind', k);
    return k;
  }
  /* visible 은 건드리지 않는다 — 번들이 미리보기(Preview) 와 인쇄 렌더에서 스스로
     끄고 켠다(visible(!w)). 우리가 visible 을 덮으면 미리보기에서 안내선이 안
     사라진다(2026-09-10 회귀 점검에서 재현). 숨길 것은 opacity 0 으로.
     여유 색칠(bleedtint)도 같은 이유로 opacity 0 — 인쇄 렌더가 스스로 1 로 올렸다가
     되돌린다. visible(false) 로 두면 인쇄 파일의 여유 띠가 비어 나간다(재현됨). */
  function guides(st) {
    var d = !!die(), n = 0, changed = false;
    st.find('.guide').forEach(function (g) {
      var k = classify(g);
      if (k === 'bleed') { changed = set(g, 'opacity', 0) || changed; n++; }
      else if (k === 'trim') { if (d) changed = set(g, 'opacity', 0) || changed; else { changed = set(g, 'stroke', C.line) || changed; changed = set(g, 'strokeWidth', 1) || changed; } n++; }
      else if (k === 'die') { changed = set(g, 'stroke', C.cut) || changed; changed = set(g, 'dash', []) || changed; changed = set(g, 'strokeWidth', 1) || changed; n++; }
    });
    st.find('.bleedtint').forEach(function (t) { changed = set(t, 'opacity', 0) || changed; });
    /* 그로밋 구멍은 손대지 않는다 — 프루프 그림도 같은 도형을 그리므로 옅게 하면
       손님이 구멍 자리를 못 본다(사장님 결정 2026-09-10: 원래대로). */
    state.guides = n;
    return changed;
  }

  /* ── 3. 안전영역 점선 — 캔버스 칸 위의 <svg> ────────────────────────
     재단 상자(trim guide)의 화면 위치·크기에서 px/in 을 얻어 그 안쪽에 그린다.
     배너: 마감 인셋(geometry.safeInset, hem+grommets 면 2in)과 1in 중 큰 쪽.
     스티커: 재단 모양(원·타원·둥근 네모) 안쪽 1/8in. */
  function safety(st) {
    var vp = document.querySelector('.canvas-viewport');
    if (!vp) return;
    var svg = document.getElementById('sbdc-safe');
    if (!svg) {
      svg = document.createElementNS(NS, 'svg');
      svg.id = 'sbdc-safe';
      svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = 'position:absolute;left:0;top:0;pointer-events:none;z-index:3;overflow:visible';
      vp.appendChild(svg);
    }
    var a = api(), trim = null;
    st.find('.guide').forEach(function (g) { if (!trim && classify(g) === 'trim') trim = g; });
    if (!a || !trim || !a.spec || !(a.spec.widthIn > 0)) { svg.innerHTML = ''; svg.removeAttribute('data-key'); state.safe = null; return; }
    /* 미리보기(Preview) 모드: 번들이 재단 상자를 visible:false 로 둔다 → 우리 점선도
       숨긴다. (스티커 재단선 diecut 은 aug.js 가 visible 없이 그려 미리보기에서도
       남는 원래 동작이라 기준으로 못 쓴다 — 재단 상자만 본다) */
    if (!trim.visible() || !trim.getLayer() || !trim.getLayer().visible()) { svg.innerHTML = ''; svg.removeAttribute('data-key'); state.safe = null; return; }
    var p = trim.getAbsolutePosition(), s = trim.getAbsoluteScale().x;
    var W = trim.width() * s, H = trim.height() * s, E = W / a.spec.widthIn;
    svg.setAttribute('width', st.width()); svg.setAttribute('height', st.height());
    var d = die(), shape, x, y, w, h, inset;
    if (d) {
      inset = SAFE_DIE_IN * E;
      x = p.x + inset; y = p.y + inset; w = W - 2 * inset; h = H - 2 * inset;
      if (d.kind === 'ellipse') shape = { t: 'ellipse', cx: x + w / 2, cy: y + h / 2, rx: w / 2, ry: h / 2 };
      else {
        var r = d.rIn != null ? d.rIn * E : Math.min(W, H) * (d.frac || 0.12);
        shape = { t: 'rect', x: x, y: y, w: w, h: h, rx: Math.max(0, r - inset) };
      }
    } else {
      var si = (a.geometry && a.geometry.safeInset) || {};
      var l = Math.max(SAFE_BASE_IN, si.left || 0) * E, t = Math.max(SAFE_BASE_IN, si.top || 0) * E,
          rr = Math.max(SAFE_BASE_IN, si.right || 0) * E, b = Math.max(SAFE_BASE_IN, si.bottom || 0) * E;
      w = W - l - rr; h = H - t - b;
      if (w <= 0 || h <= 0) { svg.innerHTML = ''; state.safe = null; return; }
      shape = { t: 'rect', x: p.x + l, y: p.y + t, w: w, h: h, rx: 0 };
    }
    var key = JSON.stringify(shape);
    if (svg.getAttribute('data-key') === key) return;
    svg.setAttribute('data-key', key);
    var el = document.createElementNS(NS, shape.t);
    if (shape.t === 'ellipse') { el.setAttribute('cx', shape.cx); el.setAttribute('cy', shape.cy); el.setAttribute('rx', shape.rx); el.setAttribute('ry', shape.ry); }
    else { el.setAttribute('x', shape.x); el.setAttribute('y', shape.y); el.setAttribute('width', shape.w); el.setAttribute('height', shape.h); if (shape.rx) el.setAttribute('rx', shape.rx); }
    el.setAttribute('fill', 'none'); el.setAttribute('stroke', C.safe); el.setAttribute('stroke-width', '1'); el.setAttribute('stroke-dasharray', '5 4');
    svg.innerHTML = ''; svg.appendChild(el);
    state.safe = shape;
  }

  /* ── 4. 선택 손잡이 — Konva.Transformer 의 읽기 함수를 덮는다 ──────────
     Transformer.update() 는 맨 끝에 anchorStyleFunc() 를 불러 손잡이를 칠하고,
     테두리는 borderStroke()/borderDash() 를 읽어 그린다. 번들은 그 함수·값을
     React 로 매 렌더 다시 넣지만, «읽는 쪽» 을 덮어 두면 무엇을 넣든 우리
     모양으로 그려진다. update 자체를 감싸는 방법은 안 된다 — 생성자에서
     this.update 를 미리 잡아 두기 때문에 나중에 바꾼 프로토타입을 안 본다. */
  var GAP = ('ontouchstart' in window) ? 11 : 7;   // 2026-09-30: handles sit outside the object (touch hit area is ~10px wider), so small text keeps its own clicks
  function restyleAnchor(an) {
    if (an.name().indexOf('rotater') >= 0) { an.visible(false); return; }   // 회전은 아래 단추로
    var n = an.name(), g = GAP;
    an.setAttrs({ fill: '#fff', stroke: C.ink, strokeWidth: 1.5, width: 10, height: 10, cornerRadius: 5,
      offsetX: 5 + (n.indexOf('left') >= 0 ? g : n.indexOf('right') >= 0 ? -g : 0),
      offsetY: 5 + (n.indexOf('top') >= 0 ? g : n.indexOf('bottom') >= 0 ? -g : 0) });
  }
  function patchTransformer() {
    var K = window.Konva;
    if (!K || !K.Transformer || K.Transformer.prototype.__sbClean) return;
    var P = K.Transformer.prototype;
    P.anchorStyleFunc = function (fn) {
      if (arguments.length) { this._sbOrigStyle = fn; return this; }         // 번들이 넣는 함수는 보관만
      var orig = this._sbOrigStyle;
      return function (an) { if (typeof orig === 'function') { try { orig(an); } catch (e) {} } if (state.on) restyleAnchor(an); };
    };
    P.borderStroke      = function (v) { if (arguments.length) { this.attrs.borderStroke = v; return this; } return state.on ? C.ink : (this.attrs.borderStroke || '#0099ff'); };
    P.borderDash        = function (v) { if (arguments.length) { this.attrs.borderDash = v; return this; } return state.on ? [] : this.attrs.borderDash; };
    P.borderStrokeWidth = function (v) { if (arguments.length) { this.attrs.borderStrokeWidth = v; return this; } return state.on ? 1 : (this.attrs.borderStrokeWidth || 1); };
    /* 회전 손잡이로 이어지는 짧은 막대(Konva rotateLineVisible) — 손잡이를 숨겼으니 막대도 */
    P.rotateLineVisible = function (v) { if (arguments.length) { this.attrs.rotateLineVisible = v; return this; } return state.on ? false : (this.attrs.rotateLineVisible !== false); };
    P.padding           = function (v) { if (arguments.length) { this.attrs.padding = v; return this; } return state.on ? GAP : (this.attrs.padding || 0); };   // 2026-09-30: the box line moves out with the handles
    P.__sbClean = true;
    (K.stages || []).forEach(function (st) { st.find('Transformer').forEach(function (tr) { try { tr.forceUpdate(); } catch (e) {} }); });
  }

  function tick() {
    if (!state.on) return;
    var st = stage();
    if (!st) return;
    patchTransformer();
    var changed = guides(st);
    safety(st);
    dims();
    state.ticks++;
    if (changed) { st.batchDraw(); state.draws = (state.draws || 0) + 1; }   // 바뀐 값이 있을 때만
  }

  var timer = setInterval(function () { try { tick(); } catch (e) { /* 편집기를 깨뜨리지 않는다 */ } }, 200);
  (function frame() { if (!state.on) return; try { var st = stage(); if (st) safety(st); } catch (e) {} requestAnimationFrame(frame); })();   // 2026-09-29: the safe line follows the board every frame (panel slide, resize, zoom), not every 0.2s
  window.addEventListener('pagehide', function () { clearInterval(timer); });

  window.__dcCanvasClean = state;
  state.off = function () { state.on = false; clearInterval(timer); var s = document.getElementById('sbdc-safe'); if (s) s.remove(); };
})();
